import { render, staticRenderFns } from "./tablelave.vue?vue&type=template&id=e9290512&scoped=true&"
import script from "./tablelave.vue?vue&type=script&lang=js&"
export * from "./tablelave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9290512",
  null
  
)

export default component.exports